// @ts-nocheck
import React from 'react';

const TaxRateDeleteAlert = React.lazy(() => import('./TaxRateDeleteAlert'));

/**
 * Tax rates alerts.
 */
export default [{ name: 'tax-rate-delete', component: TaxRateDeleteAlert }];
